import { Grid } from '@material-ui/core';
import React, { useEffect } from 'react';
import { useState } from 'react';
import { connect } from 'react-redux';
import { getFormItems } from '../../../../../../redux/forms/actions';
import { validateEmail } from '../../../../../../utils/validateEmail';
import {
	reformatPhoneString,
	validatePhoneNumber,
} from '../../../../../../utils/validatePhoneNumber';
import styles from './EditModeIndividual.module.scss';
import { makeStyles } from '@material-ui/core/styles';
import { errorMonitor } from 'events';
import CustomTextField from '../../../../../layout/customTextField/CustomTextField';
import AddressAutocomplete from '../../../../../addressAutocomplete/AddressAutocomplete';
import dayjs from 'dayjs';
import _, { update } from 'lodash';

const EditModeIndividual = ({
	formFields,
	formData,
	individualItems,
	purchaserInformation,
	setPurchaserInformation,
	error,
	setError,
}) => {
	const inputFields = _.filter(
		formFields?.fields,
		(el) => el.formName !== 'email'
	);
	const inputFormData = _.omit(formData, 'email');

	const [data, setData] = useState({});

	useEffect(() => {
		// Error clear
		setError({});

		getFormItems('agreement', 'clientInfo');
		console.log('This is the inputFormData', inputFormData);
		setData(inputFormData);

		if (individualItems) {
			var individualObjKeys = Object.keys(individualItems);
			var individualObj = {};

			individualObjKeys.forEach((key, index) => {
				var individual = individualItems[key];
				individual['dateOfBirth'] =
					individual?.identification?.report?.document?.dateOfBirth;
				console.log('individindividualual', index);

				individualObj = {
					...individualObj,
					[index]: individual,
				};
			});

			setPurchaserInformation(individualObj);
		}
	}, []);

	useEffect(() => {
		console.log('These are the purchaserInformation', purchaserInformation);
	}, [purchaserInformation]);

	const useStyles = makeStyles((theme) => ({
		textField: {
			boxShadow: '0px 1px 5px rgba(0, 0, 0, 0.1)',
			height: '44px',
			padding: '0px',
			width: '100%',
		},
		inputLabel: {
			color: 'var(--text-mid-emphasis)',
			fontSize: 'var(--text-size-small)',
			marginBottom: '10px',
			marginLeft: '5px',
		},
	}));

	const classes = useStyles();

	const handleChange = (e, key) => {
		console.log('eeee handleCHnage', e.target);
		let value = e.target.value;

		if (e.target.name === 'phoneNumber') {
			if (validatePhoneNumber(value) !== true || value === '') {
				setError({
					...error,
					[key]: {
						...error[key],
						[e.target.name]: true,
					},
				});
			} else {
				value = reformatPhoneString(e.target.value);
				error[key] && delete error[key][e.target.name];
			}
		}

		if (e.target.name === 'email') {
			if (validateEmail(value) !== true || value === '') {
				setError({
					...error,
					[key]: {
						...error[key],
						[e.target.name]: true,
					},
				});
			} else {
				error[key] && delete error[key][e.target.name];
			}
		}

		if (e.target.type === 'text' || e.target.type === 'number') {
			if (e.target.value === '') {
				setError({
					...error,
					[key]: {
						...error[key],
						[e.target.name]: true,
					},
				});
			} else {
				error[key] && delete error[key][e.target.name];
			}
		}
		e.target.type !== 'date' &&
			setPurchaserInformation({
				...purchaserInformation,
				[key]: {
					...purchaserInformation[key],
					[e.target.name]: value,
				},
			});

		if (e.target.type === 'date') {
			let today = dayjs(new Date());
			let dateChanged = dayjs(value).format('YYYY-MM-DD');
			let isBefore = dayjs(value).isBefore(today);
			if (!isBefore || dateChanged === 'Invalid Date') {
				setError({
					...error,
					[key]: {
						...error[key],
						[e.target.name]: true,
					},
				});
			} else {
				error[key] && delete error[key][e.target.name];
				setPurchaserInformation({
					...purchaserInformation,
					[key]: {
						...purchaserInformation[key],
						[e.target.name]: dateChanged,
					},
				});
			}
		}
	};

	useEffect(() => {
		console.log('data', data);
	}, [data]);

	return (
		<div className={styles.edit_mode_wrapper}>
			{Object.keys(purchaserInformation)?.map((key, index) => {
				var index = index + 1;
				var individual = purchaserInformation[key];
				return (
					<Grid
						container
						className={styles.clientWrapper}
						direction='row'
						key={key}
					>
						<Grid item xs={1} className={styles.numbering_wrapper}>
							<div className={styles.circled_number}>{index}</div>
						</Grid>
						<Grid container item xs={11} spacing={2}>
							<Grid item xs={12} sm={6}>
								{inputFields.map((field, index) => {
									return (
										<div
											key={field?.formName}
											className={styles.textField_item}
										>
											<CustomTextField
												formLabel={field.formLabel}
												name={field.formName}
												value={
													individual[
														field.formName
													] || ''
												}
												type={field.formType}
												error={
													error[key] &&
													error[key][field?.formName]
												}
												errorMessage={
													field?.errorMessage
												}
												onChange={(e) =>
													handleChange(e, key)
												}
											/>
										</div>
									);
								})}
							</Grid>
							<Grid item xs={12} sm={6}>
								<AddressAutocomplete
									formData={individual}
									setFormData={(value) =>
										setPurchaserInformation({
											...purchaserInformation,
											[key]: value,
										})
									}
									onChange={(e) => handleChange(e, key)}
									error={error[key]}
									setError={(value) =>
										setError({
											...error,
											[key]: value,
										})
									}
									defaultData={individual?.address1}
								/>
							</Grid>
						</Grid>
					</Grid>
				);
			})}
		</div>
	);
};

const mapStateToProps = (state) => ({
	formFields: state.forms.form.clientInfo?.individual,
	formData: state.forms.form.clientInfo?.individual.formData,
	individualItems: state.agreement.agreementById.clientInfo?.individual,
});

export default connect(mapStateToProps)(EditModeIndividual);
